import { render, staticRenderFns } from "./moduleLayout.vue?vue&type=template&id=8a284696&"
import script from "./moduleLayout.vue?vue&type=script&lang=js&"
export * from "./moduleLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports